import { InvoiceBatchDTO } from '../../services/apiClient';
import { TableAction } from '../common/Table';
import { FileText, Send, Landmark } from 'lucide-react';

interface InvoiceBatchActionHandlers {
  onViewBatchDetail: (batch: InvoiceBatchDTO) => void;
  onSendRenewalNotices: (batch: InvoiceBatchDTO) => void;
  onAddToNetcashBatch: (batch: InvoiceBatchDTO) => void;
}

const createInvoiceBatchActions =
  (handlers: InvoiceBatchActionHandlers) =>
  (row: InvoiceBatchDTO): TableAction[] => {
    const actions: TableAction[] = [];

    // View Batch Detail (Invoices)
    actions.push({
      label: 'View Batch Detail',
      onClick: () => handlers.onViewBatchDetail(row),
      icon: <FileText className="w-4 h-4" />,
    });

    // Send Renewal Notices
    actions.push({
      label: 'Send Renewal Notices',
      onClick: () => handlers.onSendRenewalNotices(row),
      icon: <Send className="w-4 h-4" />,
    });

    // Add all debit order invoices in this batch to the current Netcash batch
    actions.push({
      label: 'Add to Netcash Batch',
      onClick: () => handlers.onAddToNetcashBatch(row),
      icon: <Landmark className="w-4 h-4" />,
    });

    return actions;
  };

export default createInvoiceBatchActions;
